import React, { useMemo } from 'react'
import BreadcrumbItem from '../BreadcrumbItem'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

export const DynamicItems = ({ items }) => {
  const { asPath } = useRouter()

  const showMobileIndex = useMemo(
    () =>
      items.map((item) => !asPath.includes(`/${item.path}`)).lastIndexOf(true),
    [asPath, items]
  )

  return items.map((item, index) =>
    item.label !== 'Home' ? (
      <BreadcrumbItem
        key={index}
        showInMobile={showMobileIndex === index}
        disabled={!item.path || asPath.includes(`/${item.path}`)}
        path={item.path}
        label={item.label}
      />
    ) : null
  )
}

DynamicItems.propTypes = {
  items: PropTypes.array.isRequired,
}

export default React.memo(DynamicItems)
